import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ApplicationArtatech } from './application-artatech.model';
import { ApplicationArtatechService } from './application-artatech.service';
@Injectable()
export class ApplicationArtatechPopupService {
    private isOpen = false;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private applicationService: ApplicationArtatechService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.applicationService.find(id).subscribe(application => {
                application.lastModificationDate = this.datePipe.transform(application.lastModificationDate, 'yyyy-MM-ddThh:mm');
                this.applicationModalRef(component, application);
            });
        } else {
            return this.applicationModalRef(component, new ApplicationArtatech());
        }
    }

    applicationModalRef(component: Component, application: ApplicationArtatech): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.application = application;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech-popup.service.ts